import { render, staticRenderFns } from "./card-property.vue?vue&type=template&id=758e7cda&"
import script from "./card-property.vue?vue&type=script&lang=js&"
export * from "./card-property.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports